/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(contactId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetEntityContact: {
        $xmlns: 'http://dobs.pa.gov/dp/contact/bpm/1.0',
        ContactID: contactId
      }
    },
    blueprintArrays: [
      'GetEntityContactResponse.Contact.DP_EntityContactCellNumber',
      'GetEntityContactResponse.Contact.DP_EntityContactEmailAddress',
      'GetEntityContactResponse.Contact.DP_EntityContactAdditionalNumber',
      'GetEntityContactResponse.Contact.DP_EntityContactType',
      'GetEntityContactResponse.Contact.ExistingContactTypes.ContactTypeID'
    ],
    blueprint: {
      contactId: '$..ID.__text',
      entityId: '$..EntityID.__text',
      contactTypeId: '$..ContactTypeID.__text',
      contactType: '$..ContactType.__text',
      firstName: '$..FirstName.__text',
      lastName: '$..LastName.__text',
      middleInitial: '$..MiddleInitial.__text',
      title: '$..Title.__text',
      addressId: '$..AddressID.__text',
      phoneNumber: '$..PhoneNumber.__text',
      isDeleted: '$..IsDeleted.__text',
      addressLine1: '$..AddressLine1.__text',
      addressLine2: '$..AddressLine2.__text',
      addressLine3: '$..AddressLine3.__text',
      county: '$..County.__text',
      city: '$..City.__text',
      state: '$..State.__text',
      postalCode: '$..PostalCode.__text',
      country: '$..Country.__text',

      additionalNumbers: [
        '$..DP_EntityContactAdditionalNumber',
        {
          additionalNumber: '$.AdditionalNumber'
        }
      ],
      emailAddresses: [
        '$..DP_EntityContactEmailAddress',
        {
          emailAddress: '$.Email'
        }
      ],
      entityContactTypes: [
        '$..DP_EntityContactType',
        {
          contactTypeID: '$.ContactTypeID',
          contactType: '$.Type'
        }
      ],
      existingContactTypes: ['$..ContactTypeID']
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      response.existingContactTypes = _.filter(response.existingContactTypes[1], function(contact) {
        return contact !== '3' && contact !== '6';
      });

      response.entityContactTypesList = _.reduce(
        response.entityContactTypes,
        function(memo, contact, index) {
          if (response.entityContactTypes.length === 1) {
            return contact.contactType;
          }

          return response.entityContactTypes[0].contactType + '...';
        },
        ''
      );

      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
